/**
 * All custom JS by DTC
 */

/* Parallax text readability — sfondo al testo durante lo scroll */
(function () {
  if (window._parallaxTextBgInit) return;
  window._parallaxTextBgInit = true;

  function init() {
    var sections = Array.from(document.querySelectorAll('.section-image-with-text-style-9'));
    if (!sections.length) return;

    var scrollTimer = null;
    var vh = window.innerHeight;
    window.addEventListener('resize', function () { vh = window.innerHeight; }, { passive: true });

    function show(section) {
      var el = section.querySelector('.img-with-text-9__content');
      if (el) el.classList.add('is-scrolling');
    }

    function hide(section) {
      var el = section.querySelector('.img-with-text-9__content');
      if (el) el.classList.remove('is-scrolling');
    }

    // Controlla la posizione reale di ogni sezione e aggiorna lo sfondo di conseguenza.
    // Usato durante scroll e touchmove per reagire subito, senza aspettare l'IntersectionObserver asincrono.
    function updateByPosition() {
      var margin = vh * 0.1; // 10% del viewport come margine di uscita anticipata
      sections.forEach(function (s) {
        var rect = s.getBoundingClientRect();
        var inView = rect.bottom > margin && rect.top < vh - margin;
        if (inView) {
          show(s);
        } else {
          hide(s);
        }
      });
    }

    // IntersectionObserver: gestisce solo l'entrata iniziale nel viewport (con fade-in ritardato)
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          setTimeout(function () { show(entry.target); }, 100);
        }
      });
    }, { threshold: 0.05 });

    sections.forEach(function (s) { observer.observe(s); });

    // Touch: aggiorna posizione ad ogni movimento (gestisce entrata e uscita in tempo reale)
    window.addEventListener('touchmove', updateByPosition, { passive: true });
    window.addEventListener('touchstart', updateByPosition, { passive: true });

    // Touchend: nasconde tutti (dito alzato)
    window.addEventListener('touchend', function () {
      sections.forEach(hide);
    }, { passive: true });

    // Desktop: aggiorna posizione allo scroll, nasconde 2s dopo la fine
    window.addEventListener('scroll', function () {
      updateByPosition();
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        sections.forEach(hide);
      }, 2000);
    }, { passive: true });

    window.addEventListener('click', function () {
      updateByPosition();
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        sections.forEach(hide);
      }, 2000);
    }, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
